export default {
  productsInProject: [],
  projectToUpdate: null,
};
